var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.30972 0V18.7471H0V19.9965H6.55041V16.2464H8.59662C8.56034 15.8346 8.40615 15.3985 8.59662 14.997H6.55041V12.4981H9.45646C10.1276 11.6916 10.8732 11.0461 11.7893 10.5062V8.74794H14.4087V9.9974L15.7184 10.1532V0H1.30972ZM5.24069 18.7471H2.62125V16.2482H5.24069V18.7471ZM5.24069 14.9987H2.62125V12.4998H5.24069V14.9987ZM5.24069 11.2486H2.62125V8.74968H5.24069V11.2486ZM5.24069 7.49849H2.62125V4.99957H5.24069V7.49849ZM5.24069 3.75011H2.62125V1.24946H5.24069V3.75011ZM10.4814 11.2486H6.55041V8.74968H10.4814V11.2486ZM10.4814 7.49849H6.55041V4.99957H10.4814V7.49849ZM10.4814 3.75011H6.55041V1.24946H10.4814V3.75011ZM14.4105 7.49849H11.7911V4.99957H14.4105V7.49849ZM14.4105 3.75011H11.7911V1.24946H14.4105V3.75011Z",
    fill: "#06513D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4105 11.2451C11.8764 11.2451 9.82108 13.2058 9.82108 15.6234C9.82108 18.041 11.8764 20 14.4105 20C16.9447 20 18.9982 18.041 18.9982 15.6234C18.9982 13.2058 16.9447 11.2451 14.4105 11.2451ZM15.0672 16.2482V18.7471H13.7575V16.2482H11.1381V14.9987H13.7575V12.4998H15.0672V14.9987H17.6867V16.2482H15.0672Z",
    fill: "#06513D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDepartment);
export default __webpack_public_path__ + "static/media/add-department.6db1fdb71c3dac485d9711216a5f5407.svg";
export { ForwardRef as ReactComponent };